export default "__VITE_ASSET__ec819831__"